import { module, element as ngElement, IDirective } from 'angular';

/**
 * @type {IDirective}
 */
const directiveObject = {
	restrict: 'A',
	scope: {
		breakpoints: '=resizeObserver',
	},
	link(scope, element) {
		const resizeObserver = new ResizeObserver(entries => {
			for (const entry of entries) {
				if (entry.contentBoxSize) {
					const width = entry.contentBoxSize[0].inlineSize;
					const height = entry.contentBoxSize[0].blockSize;

					// @ts-ignore
					for (const [name, condition] of Object.entries(scope.breakpoints)) {
						if (condition({ width, height })) {
							ngElement(element).addClass(name);
						}
						else {
							ngElement(element).removeClass(name);
						}
					}
				}
			}
		});

		resizeObserver.observe(ngElement(element)[0]);
	},
};

const directive = () => directiveObject;

export default module('app').directive('resizeObserver', directive);
